import { Chip } from '@mui/material';
import React from 'react';
export const CptCodeChip = (props) => {
    const { code } = props;
    return (React.createElement(Chip, { style: {
            color: '#3354B2',
            backgroundColor: '#EBF0FF',
            border: '1px solid #B2C7F2',
            height: '20px',
            marginTop: '10px',
        }, label: code }));
};
